import script from "./StakeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeHeader.vue?vue&type=script&setup=true&lang=js"

import "./StakeHeader.vue?vue&type=style&index=0&id=434688e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434688e1"]])

export default __exports__